var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-donate-details',[_c('div',{staticClass:"cs-textstyle-item-heading csn-donate-details__title"},[_vm._v(" Make a one-time donation for any amount ")]),_c('div',{staticClass:"cs-textstyle-paragraph csn-donate-details__description"},[_c('p',[_vm._v("Anything you can contribute is appreciated.")])]),_c('app-donate-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }